var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.2 2 2 8.2 2 16s6.4 14 14 14 14-6.4 14-14S23.8 2 16 2m-2 6.6c0-1.2.8-2 2-2s2 .8 2 2v6.6c0 1.2-.8 2-2 2s-2-.8-2-2zm2 16c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-1 2.2-2.2 2.2"
  })));
};
export default SvgExclamationCircle;